var map = {
	"./beverages.png": "25f8",
	"./can.png": "6714",
	"./caviar.png": "43a7",
	"./clam.png": "9c34",
	"./crab.png": "ceca",
	"./cutlet.png": "df4c",
	"./delicacies-2.png": "eb4b",
	"./delicacies.png": "35c0",
	"./fish-2.png": "7e1f",
	"./fish-filet-2.png": "1895",
	"./fish-filet.png": "c42c",
	"./fish-frozen.png": "1e27",
	"./fish-net.png": "142a",
	"./fish.png": "49a1",
	"./flatfish.png": "81ad",
	"./fruits.png": "1014",
	"./gari.png": "b66d",
	"./herring.png": "3766",
	"./lobster.png": "21a5",
	"./maki.png": "4ce9",
	"./material.png": "43f9",
	"./meat.png": "4e8c",
	"./mochi.png": "51d9",
	"./octopus-2.png": "a5f6",
	"./octopus.png": "17b6",
	"./other.png": "189c",
	"./oyster.png": "cacc",
	"./salmon.png": "1b9b",
	"./sardines.png": "b55e",
	"./sea-urchin.png": "1330",
	"./seaweed.png": "15a4",
	"./shrimp-2.png": "cb5f",
	"./shrimp-frozen.png": "0119",
	"./shrimp.png": "d56c",
	"./smoked-fish.png": "3dc3",
	"./smoked.png": "e819",
	"./soya.png": "8b50",
	"./sushi.png": "3d55",
	"./tropical.png": "140f",
	"./tuna.png": "8c57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edd3";